if(!window['GlobalContext']){
    window['GlobalContext'] = {};
}

export function registerSingleton(name, instanceFactory){
    if(!window['GlobalContext'][name]){
        window['GlobalContext'][name] = instanceFactory();
    }
    return window['GlobalContext'][name];
}

const globalContext = window['GlobalContext'];
export default globalContext;
